import { jsmFeaturesEnabledResource } from '@jira/router-resources__jsm-features-enabled/src/jsmFeaturesEnabledResource.tsx';
import { useResource } from '@atlassian/react-resource-router';

export const useIsWorkforceOrLiveChatEnabled = (): boolean => {
	const { data } = useResource(jsmFeaturesEnabledResource);

	return (
		!!data?.isLiveChatEnabled ||
		(!!data?.isWorkforceOptimizationEnabled && !!data?.isWorkforceOptimizationOnboardingFinished)
	);
};
